import React, { useContext, useEffect, useState } from 'react';
import { Switch, Route, useRouteMatch } from 'react-router-dom';
import CuestionarioConfig from './CuestionarioConfig';
import DashboardConfig from './DashboardConfig';
import DashboardRiesgo from './DashboardRiesgo';
import { SessionContext } from '../shared/session';
import Requester from '../shared/Requester';

/**
 * Rutas internas del módulo Config bajo /:unidad/config.
 * Si ya existe una respuesta guardada para la unidad activa, muestra el
 * dashboard de riesgo institucional; si no, muestra el cuestionario.
 */
export default function Config() {
    const { path } = useRouteMatch();
    const session = useContext(SessionContext);
    const unidadId = session?.unidad?._id;

    const [cargando, setCargando] = useState(true);
    const [ultimaRespuesta, setUltimaRespuesta] = useState(null);

    const cargarUltimaRespuesta = () => {
        if (!unidadId) { setCargando(false); return; }
        setCargando(true);
        Requester.get(`respuestas-cuestionario/ultima?unidad_id=${unidadId}`)
            .then((res) => setUltimaRespuesta(res?.data?.respuesta || null))
            .catch(() => setUltimaRespuesta(null))
            .finally(() => setCargando(false));
    };

    useEffect(() => {
        cargarUltimaRespuesta();
    }, [unidadId]);

    if (cargando) {
        return <p className="p-3">Cargando...</p>;
    }

    return (
        <Switch>
            <Route path={`${path}/cuestionario`} exact component={CuestionarioConfig} />
            <Route path={path} exact>
                {ultimaRespuesta
                    ? (
                        <DashboardRiesgo
                            respuesta={ultimaRespuesta}
                            unidadId={unidadId}
                            onNuevoCuestionario={() => setUltimaRespuesta(null)}
                        />
                    )
                    : <DashboardConfig onGuardado={cargarUltimaRespuesta} />
                }
            </Route>
        </Switch>
    );
}
